import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-heading font-bold mb-6">
                Hipobuy Spreadsheet Guide
              </h2>
              <p className="text-foreground-300 text-sm leading-relaxed max-w-xs font-body">
                The most comprehensive English information hub about Hipobuy Spreadsheet. Helping shoppers research, compare and discover products faster with organized spreadsheet resources.
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Pinterest">
                  <i className="ri-pinterest-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Reddit">
                  <i className="ri-reddit-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-full border border-foreground-400 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="Discord">
                  <i className="ri-discord-line text-sm"></i>
                </a>
              </div>
            </div>

            <div className="space-y-8">
              <div>
                <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-3">Quick Links</h4>
                <div className="space-y-2">
                  <Link to="/" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Home</Link>
                  <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Main Website</a>
                  <Link to="/hipobuy-spreadsheet-complete-guide" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Complete Guide</Link>
                  <Link to="/hipobuy-spreadsheet-safety" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Safety Guide</Link>
                </div>
              </div>
              <div>
                <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-3">Comparisons</h4>
                <div className="space-y-2">
                  <Link to="/hipobuy-vs-kakobuy" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Kakobuy Spreadsheet</Link>
                  <Link to="/hipobuy-vs-cssbuy" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">CSSBuy Spreadsheet</Link>
                  <Link to="/hipobuy-vs-superbuy" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Superbuy Spreadsheet</Link>
                  <Link to="/hipobuy-vs-oopbuy" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Oopbuy Spreadsheet</Link>
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-400 mb-3">SEO Resources</h4>
              <div className="space-y-2 mb-8">
                <Link to="/hipobuy-spreadsheet-complete-guide" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Hipobuy Spreadsheet Complete Guide 2026</Link>
                <Link to="/hipobuy-spreadsheet-beginner" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Beginner Tutorial</Link>
                <Link to="/hipobuy-spreadsheet-safety" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Safety Education</Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="block text-sm text-foreground-300 hover:text-background-50 transition-colors font-body">Shop Now</a>
              </div>
              <div className="rounded-2xl overflow-hidden w-full max-w-[200px] aspect-[3/4]">
                <img
                  src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20lifestyle%20product%20photography%20on%20cream%20background%2C%20clean%20editorial%20aesthetic%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20modern%20commercial%20style%20with%20organic%20texture%20and%20elegant%20composition&width=400&height=533&seq=footer-product&orientation=portrait"
                  alt="Hipobuy Spreadsheet product showcase"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500 font-body">
              &copy; 2026 Hipobuy Spreadsheet Guide. All rights reserved. Not affiliated with Hipobuy, Kakobuy, CSSBuy, Superbuy or Oopbuy.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors font-body">Privacy Policy</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors font-body">Terms of Service</a>
              <Link to="/hipobuy-spreadsheet-complete-guide" className="text-xs text-foreground-500 hover:text-background-50 transition-colors font-body">SEO Guide</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}